import {defineSlotRecipe} from '@chakra-ui/react3'

export const assetSlotRecipe = defineSlotRecipe({
    className: 'asset',
    slots: ['container', 'bottomGradient', 'videoControlBox'],

    base: {
        container: {
            position: 'relative',
            w: '100%',
            h: '100%'
        },
        bottomGradient: {
            position: 'absolute',
            bottom: '0',
            left: '0',
            right: '0',
            height: '10.219rem',
            bg: 'gradient.bottom.darken-40',
            pointerEvents: 'none'
        },
        videoControlBox: {
            position: 'absolute',
            zIndex: 'overlay'
        }
    },
    variants: {
        variant: {
            default: {
                videoControlBox: {
                    bottom: 'spacing-16',
                    right: 'spacing-16'
                }
            },
            gallery: {
                videoControlBox: {
                    top: {base: 'spacing-24', s: 'auto'},
                    bottom: {base: 'auto', s: 'spacing-24'},
                    right: 'spacing-24'
                }
            }
        }
    },

    defaultVariants: {variant: 'default'}
})
